import { MouseEventHandler, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useDebounceValue } from '@hooks/hooks';
import { SEARCH_LENGTH } from '@utils/utils';
import { SearchViewModel } from '@api/v3';

import { BookerSearchViewModel } from '../BookerSearchViewModel';
import DesktopHotelSearchDrawer from './DesktopHotelSearchDrawer';
import { useGetPopularSearches } from '../../hooks';

type Props = {
  type: string;
  placeholder: string;
  onInputLocationChange?: (item: BookerSearchViewModel) => void;
  responsiveTitle: string;
  fetchItems: (param: string) => Promise<BookerSearchViewModel[]>;
  onHrefUpdate?: (href: string) => void;
  onSearchItemTextUpdate?: (itemText: string) => void;
  history?: BookerSearchViewModel[];
  onClearClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  callBack?: (item: BookerSearchViewModel) => void;
  onRemoveItem?: (item: BookerSearchViewModel) => void;
  error?: boolean;
  href?: string;
  cyprus?: boolean;
  onPopularSearchItemSelected?: (item: SearchViewModel) => void;
};

const HotelSearchDrawer = ({
  placeholder,
  type,
  onInputLocationChange,
  fetchItems,
  onHrefUpdate,
  onSearchItemTextUpdate,
  history,
  onClearClick,
  callBack,
  onRemoveItem,
  error,
  href,
  cyprus,
  onPopularSearchItemSelected,
}: Props) => {
  const { items: popularSearchItems } = useGetPopularSearches({
    type: 'hotel',
  });

  const [location] = useState<BookerSearchViewModel>();
  const [inputLocation, setInputLocation] = useState<string>(
    location?.text || ''
  );
  const debouncedLocation = useDebounceValue<string>(inputLocation);

  const { data: locations = [], isError: searchTextError } = useQuery(
    ['locationItems', debouncedLocation],
    () => fetchItems(debouncedLocation.toLowerCase()),
    { enabled: debouncedLocation.length >= SEARCH_LENGTH }
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void =>
    setInputLocation(e.target.value);

  const handleLocationClicked = (item: BookerSearchViewModel): void => {
    onSearchItemTextUpdate?.(item.text || '');
    onHrefUpdate?.(item.url || '');
    setInputLocation(item.text || '');
    onInputLocationChange?.(item);

    if (type === 'Tour') {
      const currentHref = href?.split('?')?.[1];
      onHrefUpdate?.(`${item.url}${currentHref ? `?${currentHref}` : ''}`);
      return;
    }
    onHrefUpdate?.(item.url || '');
  };

  return (
    <DesktopHotelSearchDrawer
      locations={locations}
      handleChange={handleChange}
      handleLocationClicked={handleLocationClicked}
      searchTextError={searchTextError}
      placeholder={placeholder}
      inputLocation={inputLocation}
      error={error}
      history={history}
      onClearClick={onClearClick}
      onRemoveItem={onRemoveItem}
      callBack={callBack}
      cyprus={cyprus}
      popularSearchItems={popularSearchItems}
      onPopularSearchItemSelected={onPopularSearchItemSelected}
    />
  );
};

export default HotelSearchDrawer;
